/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { DropdownItem } from './dropdown-helpers';

export const LozengeWrapper = styled.span`
  padding-left: 8px;
`;

export const NonInteractiveDropdownItem = styled(DropdownItem)`
  pointer-events: none;
`;

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;

export const DisplayName = styled.div`
  line-height: 20px;
`;
